import { axiosInstance } from "../../utils";

const actions = {
  FETCH_ANALYTICS_REQUESTED: "FETCH_ANALYTICS_REQUESTED",
  FETCH_ANALYTICS_SUCCEEDED: "FETCH_ANALYTICS_SUCCEEDED",
  FETCH_ANALYTICS_FAILED: "FETCH_ANALYTICS_FAILED",

  FETCH_TOTAL_REVENUE_REQUESTED: "FETCH_TOTAL_REVENUE_REQUESTED",

  fetchAnalytics: (params = undefined) => {
    return {
      type: actions.FETCH_ANALYTICS_REQUESTED,
      payload: params,
    };
  },

  fetchTotalRevenue: (params = undefined) => {
    return {
      type: actions.FETCH_TOTAL_REVENUE_REQUESTED,
      payload: params,
    };
  },

  getAnalytics: async (data = undefined) => {
    let revenuePerMonthURL = `dashboard/revenue?group_by=day`;
    let completedOrdersUrl = `dashboard/orders`;
    if (data?.totalRevenue && Object.keys(data?.totalRevenue || {}).length) {
      var fromDate = new Date(data.totalRevenue.from_date._d);
      var toDate = new Date(data.totalRevenue.to_date._d);
      toDate.setDate(toDate.getDate() + 1);
      revenuePerMonthURL = `dashboard/revenue?from_date=${fromDate.toISOString()}&to_date=${toDate.toISOString()}&group_by=day`;
      completedOrdersUrl = `dashboard/orders?from_date=${fromDate.toISOString()}&to_date=${toDate.toISOString()}`;
    }
    var date = new Date();
    date.setDate(1);
    const thisMonthStart = new Date(
      date.getFullYear(),
      date.getMonth(),
      1
    ).toISOString();
    date.setMonth(date.getMonth() - 1);
    var firstDay = new Date(
      date.getFullYear(),
      date.getMonth(),
      1
    ).toISOString();
    var lastDay = new Date(
      date.getFullYear(),
      date.getMonth() + 1,
      0
    ).toISOString();

    const statisticsUrl = `dashboard/statistics`;
    const orderValuesUrl = `dashboard/revenue`;
    const completedOrdersPerMonthUrl = `dashboard/orders?group_by=month`;
    const revenueURL = `dashboard/revenue?from_date=${firstDay}&to_date=${lastDay}&group_by=day`;
    const accountingStatisticsUrl = `accounting/statistics`;
    const revenueThisMonthURL = `dashboard/revenue?from_date=${thisMonthStart}`;
    const pillveryCommissionUrl = "dashboard/revenue?value_type=revenue";
    const pillveryCommission2Url = "dashboard/numbers";

    try {
      const statistics = await axiosInstance.get(statisticsUrl, data);
      const ordersValue = await axiosInstance.get(orderValuesUrl, data);
      const completedOrders = await axiosInstance.get(completedOrdersUrl, data);
      const completedOrdersPerMonth = await axiosInstance.get(
        completedOrdersPerMonthUrl,
        data
      );
      const revenue = await axiosInstance.get(revenueURL, data);
      const revenuePerMonth = await axiosInstance.get(
        revenuePerMonthURL,
        data?.totalRevenue
      );
      const accountingStatistics = await axiosInstance.get(
        accountingStatisticsUrl,
        data
      );
      const revenueThisMonth = await axiosInstance.get(
        revenueThisMonthURL,
        data
      );
      const pillveryCommission = await axiosInstance.get(
        pillveryCommissionUrl,
        data
      );
      const pillveryCommission2 = await axiosInstance.get(
        pillveryCommission2Url,
        data
      );

      return {
        ...statistics?.data,
        ordersValue: ordersValue?.data,
        completedOrders: completedOrders?.data,
        revenue: revenue?.data,
        revenueThisMonth: revenueThisMonth?.data,
        revenuePerMonth: revenuePerMonth?.data,
        completedOrdersPerMonth: completedOrdersPerMonth?.data,
        accountingStatistics: accountingStatistics?.data,
        pillveryCommission: pillveryCommission?.data,
        pillveryCommission2: pillveryCommission2?.data,
      };
    } catch (error) {
      throw error;
    }
  },
};

export default actions;
